import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, ViewEncapsulation,} from '@angular/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {
  SupportOrderDataLoadingService
} from "../../../../services/support/support-order/support-order-data-loading.service";
import {Order} from "../../../../model/clearing/order";
import {SupportOrderService} from "../../../../services/support/support-order/support-order.service";
import {
  SupportOrderBatchFormConfigService
} from "../../../../services/support/support-order/support-order-batch-form-config.service";
import {BatchUpdateRequest} from "../../../../model/api/batch-update-request";
import {BatchActionBaseFormComponent} from "../../../../crystal-elements/batch-action-base-form.component";
import {DecimalPipe} from "@angular/common";
import {PrepareForSaveDateFields} from "../../../../utils/form-helper";

@Component({
  selector: 'app-batch-action-support-order-form',
  templateUrl: './batch-action-support-order-form.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [MessageService, ConfirmationService, TranslateService, DecimalPipe]
})
export class BatchActionSupportOrderFormComponent
  extends BatchActionBaseFormComponent<Order, SupportOrderBatchFormConfigService> {

  @Input()
  dataLoadingService: SupportOrderDataLoadingService

  constructor(
    cdref: ChangeDetectorRef,
    messageService: MessageService,
    translateService: TranslateService,
    confirmationService: ConfirmationService,
    formConfigService: SupportOrderBatchFormConfigService,
    private readonly supportOrderService: SupportOrderService
  ) {
    super(
      cdref,
      messageService,
      translateService,
      confirmationService,
      formConfigService
    );
  }

  protected getSaveAction(request: BatchUpdateRequest<Order>) {
    PrepareForSaveDateFields(request.recordToApply, this.formConfig);
    return this.supportOrderService.saveBatch(request);
  }
}
